import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { PageComponentTitleMode, TitleInfo } from '../../../common/interfaces';

@Component({
    selector: 'vsf-title-box',
    templateUrl: './title-box.component.html',
    styleUrls: ['./title-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitleBoxComponent implements OnChanges {
    @Input() titleInfo: TitleInfo | null = null;
    @Input() forComponent: boolean = false;
    @Input() forSection: boolean = false;
    titleMode: PageComponentTitleMode = 'disabled';
    title: string = '';
    subtitle: string = '';
    titleUnderline: boolean = false;
    isPageHeading: boolean = false;
    h1StyleMode: string = 'auto';
    display: boolean = false;

    ngOnChanges(): void {
        if(this.titleInfo) {
            this.title = this.titleInfo.title || '';
            this.subtitle = this.titleInfo.subtitle || '';
            this.titleMode = this.titleInfo.titleMode || (this.title || this.subtitle ? 'for-section' : 'disabled');
            this.titleUnderline = this.titleInfo.titleUnderline === true;
            this.isPageHeading = this.titleInfo.isPageHeading === true;
            this.h1StyleMode = this.titleInfo.h1StyleMode || 'auto';
        } else {
            this.title = '';
            this.subtitle = '';
            this.titleMode = 'disabled';
            this.titleUnderline = false;
        }

        this.display = (this.title.length > 0 || this.subtitle.length > 0) &&
            ((this.forComponent && this.titleMode === 'for-component') ||
             (this.forSection && this.titleMode === 'for-section'));
    }
}